import { render, staticRenderFns } from "./StatusUnder.vue?vue&type=template&id=1e538da0&scoped=true"
import script from "./StatusUnder.vue?vue&type=script&lang=js"
export * from "./StatusUnder.vue?vue&type=script&lang=js"
import style0 from "./StatusUnder.vue?vue&type=style&index=0&id=1e538da0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e538da0",
  null
  
)

export default component.exports